// extracted by mini-css-extract-plugin
export default {"button":"Dl-z","reviewSort":"El-z"};